'use client';
// react-scan must be imported before react
import { scan } from 'react-scan';
import { JSX, useEffect } from 'react';

export function ReactScan(): JSX.Element {
  useEffect(() => {
    console.log('react-scan');
    scan({
      enabled: true,
      dangerouslyForceRunInProduction: true,
    });
  }, []);

  return <></>;
}
